import { Component, OnInit, ElementRef, Injector, Input, ChangeDetectionStrategy } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';

/**
 * Component wrapper for RolesController
 */
@Component({
  selector: 'roles-list',
  template: '<roles-list-directive></roles-list-directive>',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class RolesListComponent implements OnInit {
  constructor() {}

  ngOnInit() {
    // No specific route params needed for roles list component
  }
}

/**
 * Directive for downgrading RolesListComponent
 */
@Component({
  selector: 'roles-list-directive',
  template: '',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class RolesListDirective extends UpgradeComponent {
  constructor(elementRef: ElementRef, injector: Injector) {
    super('rolesList', elementRef, injector);
  }
}

/**
 * Component wrapper for RoleController
 */
@Component({
  selector: 'role-form',
  template: '<role-form-directive [id]="id"></role-form-directive>',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class RoleFormComponent {
  @Input() id: string;
}

/**
 * Directive for downgrading RoleFormComponent
 */
@Component({
  selector: 'role-form-directive',
  template: '',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class RoleFormDirective extends UpgradeComponent {
  @Input() id: string;

  constructor(elementRef: ElementRef, injector: Injector) {
    super('roleForm', elementRef, injector);
  }
}
